module.exports = __webpack_public_path__ + "assets/img/login-bg@2x.ef0578b3.png";